import * as B from '@blueprintjs/core';
import React from 'react';

import {ConversionWarnings} from 'app/modules/Remote/Admin/types';

import {CollapsibleImpactCallout} from './CollapsibleImpactCallout';
import {ImpactedPropertyLinks} from './ImpactedPropertyLinks';

export const ReportsImpactCallout: React.FunctionComponent<{
  conversionWarnings: ConversionWarnings | null;
}> = ({conversionWarnings}) => {
  const archivedProperties = conversionWarnings?.MULTI_LOCATION_REPORTS_WARNING?.reports ?? [];
  const updatedProperties = conversionWarnings?.REPORTS_WARNING?.reports ?? [];
  const hasReportsImpact = archivedProperties.length > 0 || updatedProperties.length > 0;

  if (!hasReportsImpact) return null;

  const propertyCount = new Set(
    [...archivedProperties, ...updatedProperties].map((p) => p.featureId)
  ).size;

  return (
    <CollapsibleImpactCallout
      intent={archivedProperties.length > 0 ? B.Intent.DANGER : B.Intent.WARNING}
      title="Archive & Update Notice"
      summary={`This update will affect saved reports for ${propertyCount} ${
        propertyCount === 1 ? 'property' : 'properties'
      }.`}
    >
      If you need current versions, download them now from each property page:
      <ul>
        {archivedProperties.length > 0 && (
          <li>
            <strong>Will be archived:</strong>{' '}
            <ImpactedPropertyLinks properties={archivedProperties} />
          </li>
        )}
        {updatedProperties.length > 0 && (
          <li>
            <strong>Will be updated with new bounds:</strong>{' '}
            <ImpactedPropertyLinks properties={updatedProperties} />
          </li>
        )}
      </ul>
    </CollapsibleImpactCallout>
  );
};
